import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const { exchangeGoogleSession } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match ? decodeURIComponent(match[1]) : null;
    if (!session_id) {
      setError("No se recibió session_id");
      return;
    }
    (async () => {
      try {
        await exchangeGoogleSession(session_id);
        // Clean URL hash and go to dashboard
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || "No se pudo iniciar sesión con Google");
      }
    })();
  }, [exchangeGoogleSession, navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-paper px-6">
      <div className="text-center">
        <p className="text-[11px] tracking-[0.22em] uppercase text-copper font-medium">
          unaTESIS
        </p>
        <h1 className="mt-3 font-serif text-3xl text-ink">
          {error ? "No pudimos iniciarte sesión" : "Validando tu cuenta…"}
        </h1>
        <p className="mt-3 text-ink-soft text-sm max-w-sm mx-auto">
          {error || "Estamos verificando tu sesión con Google. Esto tarda solo un instante."}
        </p>
        {error && (
          <button
            data-testid="auth-callback-retry"
            onClick={() => navigate("/login", { replace: true })}
            className="mt-6 inline-flex items-center px-5 py-2.5 rounded-full text-sm font-medium text-paper bg-forest hover:bg-forest-dark"
          >
            Volver al inicio de sesión
          </button>
        )}
      </div>
    </div>
  );
}
